module.exports = __webpack_public_path__ + "img/d201005-1.081d9b14.jpg";